import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorIncentivosUSeminuevos = ({ rango = null, setTotal = null }) => {

    const [state, setState] = useState({
        meta: 0,
        real: 0,
        costo: 0,
        cumplimiento: 0,
        margen: 0,
        porcentaje: 0,
        incentivo: 0
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };

    useEffect(() => {
        // var margen = 0;

        if (Number(state.meta) !== 0 && Number(state.real) !== 0 && Number(state.costo) !== 0) {
            const cumplimiento = truncar((Number(state.real) / Number(state.meta)) * 100); 
            let margen = 0;
            if (Number(state.costo) < Number(state.real)) {
                margen = (Number(state.real) - Number(state.costo)) / Number(state.real);
            } else {
                margen = 0;
            }
            // if (margen < 0) margen = 0;
            let rangoUso = "";
            if (margen >= 0 && margen < 0.15) {
                rangoUso = "bajo";
            } else if (margen >= 0.15 && margen <= 0.20) {
                rangoUso = "medio";
            } else if (margen > 0.20) {
                rangoUso = "alto";
            }
            var porcentaje = 0;
            var incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
                        if (rangoUso === "bajo") {
                            porcentaje = index.margen_bajo;
                        } else if (rangoUso === "medio") {
                            porcentaje = index.margen_medio;
                        } else if (rangoUso === "alto") {
                            porcentaje = index.margen_alto;
                        }
                        incentivo = Number(state.real) * porcentaje;
                    }
                });
            }

            setState({
                ...state,
                cumplimiento,
                margen: margen * 100,
                porcentaje: porcentaje * 100,
                incentivo,
            });

            if (setTotal)
                setTotal(incentivo);
        }
    }, [state.meta, state.real, state.costo]);

    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Objetivo de venta</div>
                    <SimuladorNumericInput
                        name="meta"
                        label=""
                        value={state.meta}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Venta total</div>
                    <SimuladorNumericInput
                        name="real"
                        label=""
                        value={state.real}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>

                <div className="input-section">
                    <div className="input-title-label">Costo de maquinaria usada</div>
                    <SimuladorNumericInput
                        name="costo"
                        label=""
                        value={state.costo}
                        disabled={false}
                        onChange={handleChange}
                        icono="pesos"
                    />
                </div>
            </div>

            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Cumplimiento de venta</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={state.cumplimiento}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>

                <div className="input-section">
                    <div className="input-title-label">Margen bruto</div>
                    <SimuladorNumericInput
                        name="porcentaje"
                        label=""
                        value={state.margen}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>

            <div className="input-container-one">

                <div className="input-section">
                    <div className="input-title-label">% Incentivo a ganar</div>
                    <SimuladorNumericInput
                        name="porcentaje"
                        label=""
                        value={state.porcentaje}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>

            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-section-label">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div >
    );
};
